import { render, staticRenderFns } from "./MarkdownView.vue?vue&type=template&id=ebb20582&scoped=true"
import script from "./MarkdownView.vue?vue&type=script&lang=js"
export * from "./MarkdownView.vue?vue&type=script&lang=js"
import style0 from "./MarkdownView.vue?vue&type=style&index=0&id=ebb20582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb20582",
  null
  
)

export default component.exports